import React from "react";
import QtyInput from "../../components/Reusable/QtyInput";
import { fetchAddQty, fetchRemoveQty } from "../../actions/catalog";
import { useDispatch } from "react-redux";
import { t } from "i18next"; // Import t function for translation

const CartListItem = (props) => {
  const { product } = props || {};

  const dispatch = useDispatch();

  const changeCartItem = (product, qty, type) => {
    const item = {
      productId: product.productId,
      quantity: qty,
    };

    if (type === "add") {
      dispatch(fetchAddQty(item));
    } else {
      dispatch(fetchRemoveQty(item, type));
    }
  };

  return (
    <div className="product-list-item">
      <div className="product-list-item-context">
        <div className="product-list-item-title">{product.name}</div>
        <div className="product-list-item-points">
          <div className="product-list-item-points-item">
            {t("cartListItem.pointsLabel")}
            <span className={product?.promotionPoints !== null && "points"}>
              {product.points}
            </span>
            {product?.promotionPoints !== null && (
              <span className="promotion-points">
                {product?.promotionPoints}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="product-list-item-qty">
        <QtyInput
          value={product?.quantity}
          buttonShow={false}
          onChange={(newQty, type) => changeCartItem(product, newQty, type)}
          onChangeRemoveItem={(qty) => changeCartItem(product, qty, "delete")}
        />
      </div>
    </div>
  );
};

export default CartListItem;
